// This file serves for all custom variables/functions that are used in the app

// Custom rendering for persons per night on RatesPicker
export const customRenderingPPNOrganizations = ["Wine Camp Hažić", "Camp Zagreb"];

export const hideTermsAndPrivacyPolicy = ["Campuccino"];

export const getCampuccinoLinks = (lang: string) => {
  if (lang === "sr") {
    return {
      privacy: "https://campuccino.org/sr/politika-privatnosti/",
      terms: "https://campuccino.org/sr/uslovi-koriscenja/",
    };
  }
  if (lang === "de") {
    return {
      privacy: "https://campuccino.org/de/datenschutzerklaerung/",
      terms: "https://campuccino.org/de/nutzungsbedingungen/",
    };
  }
  return {
    privacy: "https://campuccino.org/privacy-policy/",
    terms: "https://campuccino.org/terms-and-conditions/",
  };
};
